import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import { primaryNav } from "../scripts/primary-nav.js";
import { carousel } from "../scripts/carousel.js";
import { table } from "../scripts/table.js";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

window.addEventListener("DOMContentLoaded", function () {
  primaryNav();
  carousel();
  table();
});
